import React, { useState } from "react";
import axios from "axios";
import "../assets/CSS/uploads.css";

const useUploads = () => {
  const [image, setImage] = useState(null);
  const [text, setText] = useState("");
  const [showTextBox, setShowTextBox] = useState(false);
  const [published, setPublished] = useState(false);

  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event) => {
      const file = event.target.files[0];
      if (file) {
        console.log("Image chosen:", file.name);
        setImage(file);
      } else {
        console.log("No file selected");
        setImage(null);
      }
    };
    input.click();
  };

  const addText = () => {
    console.log("Opening textfield");
    setShowTextBox(true);
  };

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  const upload = async () => {
    console.log("Upload-Function was called");

    if (text.trim() === "" && !image) {
      alert("Add text or a picture before you post a Zing!");
      return;
    }

    const formData = new FormData();
    formData.append("caption", text);
    formData.append("userId", "1"); // Som streng

    if (image) {
      formData.append("image", image);
      console.log("Adding picture:", image.name);
    }

    // Debug: logg alle felt
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}: [Fil] ${value.name}`);
      } else {
        console.log(`${key}: ${value}`);
      }
    }

    try {
      const response = await axios.post("`${process.env.REACT_APP_API_URL}/posts", formData);
      console.log("Upload successful:", response.data);

      setPublished(true);
      setText("");
      setImage(null);
      setShowTextBox(false);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Something went wrong uploading.");
    }
  };

  return {
    addImage,
    addText,
    handleTextChange,
    upload,
    text,
    showTextBox,
    published
  };
};

export default useUploads;
